import { Check } from 'lucide-react'
import { cn } from '@/lib/utils'

interface WizardStepperProps {
  steps: string[]
  current: number
}

export function WizardStepper({ steps, current }: WizardStepperProps) {
  return (
    <div className="overflow-x-auto -mx-1 px-1">
      <div className="flex items-center min-w-max">
        {steps.map((step, index) => (
          <div key={step} className="flex items-center">
            <div className="flex flex-col items-center gap-1">
              <div className={cn(
                'w-7 h-7 rounded-full flex items-center justify-center text-xs font-semibold border-2 shrink-0',
                index < current
                  ? 'bg-[#076698] border-[#076698] text-white'
                  : index === current
                    ? 'bg-[#076698] border-[#076698] text-white'
                    : 'bg-background border-border text-muted-foreground'
              )}>
                {index < current ? <Check size={12} /> : index + 1}
              </div>
              <span className={cn(
                'text-xs whitespace-nowrap',
                index <= current ? 'text-[#076698] font-medium' : 'text-muted-foreground'
              )}>
                {step}
              </span>
            </div>
            {index < steps.length - 1 && (
              <div className={cn(
                'h-0.5 min-w-[32px] mx-2 mb-4',
                index < current ? 'bg-[#076698]' : 'bg-border'
              )} />
            )}
          </div>
        ))}
      </div>
    </div>
  )
}
